export interface Credentials {
  username: string;
  password: string;
}

export class Credentials implements Credentials {
  constructor(username?: string, password?: string) {
    if (username) {
      this.username = username;
    }
    if (password) {
      this.password = password;
    }
  }
}
